<template>
    <div
        class="weixin-collect-input"
        v-loading="loading"
        element-loading-text="正在加载文章内容。如果文章图片较多，可能时间会较慢，请耐心等候。"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-input class="collection-input" v-model="address" placeholder="输入微信公众号文章链接地址，可采集文章内容到下方编辑区"></el-input>
        <el-button class="collection-btn" type="primary" @click="collectHandler" :disabled="!collection_address">采集</el-button>
    </div>
</template>

<script>
import apiPath from '@/service/apiPath.js';
import { requestApi } from '@/service/requestApi.js';

export default {
    name: "weixin-collect-input",
    model: {
        prop: 'collection_address',
        event: 'change'
    },
    props: {
        'collection_address': String,
    },
    watch: {
    },
    data() {
        return {
            loading: false,
            formRules: {
                collection_address: {type: 'pattern', pattern: /^http(s)?:\/\/(.)/,  message: '请输入正确的链接格式，如: https://mp.weixin.qq.com/xxx', trigger: 'blur'},
            }
        }
    },
    computed: {
        address: {
            get: function() {
                return this.collection_address;
            },
            set: function(val) {
                this.$emit('change', val);
            }
        }
    },
    components: {
    },
    methods: {
        collectHandler() {
            const rules = this.formRules.collection_address;
            if (!rules.pattern.test(this.address)) {
                this.$message({
                    type: 'warning',
                    message: rules.message,
                    duration: 3000
                });
                return;
            }
            let submitForm = {
                address: this.address
            };
            this.loading = true;
            requestApi({
                url: apiPath.WEIXIN_COLLECT,
                method: 'post',
                body: submitForm,
                options: {
                    timeout: 60 * 1000
                },
                successFn: (data) => {
                    this.$emit('collect-res', data.html);
                    this.loading = false;
                    if (!data.err_img) {
                        this.$message({
                            type: 'success',
                            message: `文章内容采集完成`,
                            duration: 1500
                        });
                    } else {
                        this.$message({
                            type: 'warning',
                            message: `文章内容采集中有${data.err_img}张图片转存失败，请重新采集`,
                            duration: 3000
                        });
                    }
                }
            }).then(() => {
                this.loading = false;
            });

        },
    }
};
</script>

<style lang="less">
    @import (reference) '../styles/public.less';
    .weixin-collect-input {
        .collection-input {
            width: 90%;
            float: left;
            @media screen and (max-width: 1024px) {
                width: 80%;
            }
            @media screen and (max-width: 580px) {
                width: 70%;
            }
        }
        .collection-btn {
            float: right;
        }
        .el-loading-spinner {
            background-color: rgba(255,255,255,0.8);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/weixinCollectInput.vue